import app from 'flarum/forum/app';
import extendLogInButtons from './extendLogInButtons';
import extendWelcomeHero from './extendWelcomeHero';
app.initializers.add('batmannews-oauth-disqus', () => {
  extendLogInButtons();
  extendWelcomeHero();
});